import { NgModule } from '@angular/core';
import { ChatAppComponent } from './chat.app.component';
import { ChatBoxComponent } from './chat-box/chat-box.component';
import { ChatSidebarComponent } from './chat-sidebar/chat-sidebar.component';
import { UserCardComponent } from './user-card/user-card.component';

@NgModule({
    imports: [
        ChatAppComponent,
        ChatBoxComponent,
        ChatSidebarComponent,
        UserCardComponent
    ],
    exports: [
        ChatAppComponent,
        ChatBoxComponent
    ]
})
export class ChatAppModule { }
